export default "__VITE_ASSET__X2XqttZc__"